import { isRouteErrorResponse, useNavigate, useRouteError } from 'react-router-dom'
import { AlertTriangle, RotateCw } from 'lucide-react'

/**
 * Catches render and loader errors so one broken screen does not blank the
 * whole app. Deliberately shows the raw message: this is an internal tool, and
 * "Could not load bank_accounts: relation does not exist" is far more useful to
 * the person hitting it than a generic apology.
 */
export function RouteErrorBoundary() {
  const error = useRouteError()
  const navigate = useNavigate()

  const detail = isRouteErrorResponse(error)
    ? `${error.status} ${error.statusText}`
    : error instanceof Error
      ? error.message
      : 'An unexpected error occurred.'

  return (
    <div className="flex min-h-dvh items-center justify-center bg-canvas px-4">
      <div className="max-w-lg rounded-card border border-border bg-surface p-6">
        <div className="flex items-start gap-3">
          <AlertTriangle className="mt-0.5 size-5 shrink-0 text-warning" aria-hidden />
          <div className="min-w-0">
            <h1 className="text-base font-semibold text-fg">Something broke on this screen</h1>
            <p className="mt-2 break-words font-mono text-xs text-fg-secondary">{detail}</p>

            <div className="mt-5 flex gap-2">
              <button
                type="button"
                onClick={() => window.location.reload()}
                className="flex h-9 items-center gap-2 rounded-control bg-accent px-3 text-sm font-medium text-fg-on-accent transition-colors hover:bg-accent-hover"
              >
                <RotateCw className="size-4" aria-hidden />
                Reload
              </button>
              <button
                type="button"
                onClick={() => navigate('/')}
                className="h-9 rounded-control border border-border-strong px-3 text-sm text-fg-secondary transition-colors hover:bg-surface-hover hover:text-fg"
              >
                Go to dashboard
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
